import types from "./types";

const INITIAL_STATE = {
	technician: null,
	technicianError: null,
	technicianLoading: false,

	//create
	createtechnician: null,
	createtechnicianError: null,
	createtechnicianLoading: false,

	//update
	updatetechnician: null,
	updatetechnicianError: null,
	updatetechnicianLoading: false,

	//delete
	deletetechnician: null,
	deletetechnicianError: null,
	deletetechnicianLoading: false,

	//single item

	singleItem: null,
};

const StoreReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_TECHNICIAN_START:
			return {
				...state,
				technician: null,
				technicianError: null,
				technicianLoading: true,
			};
		case types.GET_TECHNICIAN_SUCCESS:
			return {
				...state,
				technician: action.payload,
				technicianLoading: false,
			};
		case types.GET_TECHNICIAN_ERROR:
			return {
				...state,
				technicianError: action.payload,
				technicianLoading: false,
			};
		case types.GET_TECHNICIAN_RESET:
			return {
				...state,
				technicianError: null,
				technicianLoading: false,
			};
		//create

		case types.CREATE_TECHNICIAN_START:
			return {
				...state,
				createtechnician: null,
				createtechnicianError: null,
				createtechnicianLoading: true,
			};
		case types.CREATE_TECHNICIAN_SUCCESS:
			return {
				...state,
				createtechnician: action.payload,
				createtechnicianLoading: false,
			};
		case types.CREATE_TECHNICIAN_ERROR:
			return {
				...state,
				createtechnicianError: action.payload,
				createtechnicianLoading: false,
			};
		case types.CREATE_TECHNICIAN_RESET:
			return {
				...state,
				createtechnicianError: null,
				createtechnicianLoading: false,
			};
		//delete

		case types.DELETE_TECHNICIAN_START:
			return {
				...state,
				deletetechnician: null,
				deletetechnicianError: null,
				deletetechnicianLoading: true,
			};
		case types.DELETE_TECHNICIAN_SUCCESS:
			return {
				...state,
				deletetechnician: action.payload,
				deletetechnicianLoading: false,
			};
		case types.DELETE_TECHNICIAN_ERROR:
			return {
				...state,
				deletetechnicianError: action.payload,
				deletetechnicianLoading: false,
			};
		case types.DELETE_TECHNICIAN_RESET:
			return {
				...state,
				deletetechnician: null,
				deletetechnicianError: null,
				deletetechnicianLoading: false,
			};

		//update
		case types.UPDATE_TECHNICIAN_START:
			return {
				...state,
				updatetechnician: null,
				updatetechnicianError: null,
				updatetechnicianLoading: true,
			};
		case types.UPDATE_TECHNICIAN_SUCCESS:
			return {
				...state,
				updatetechnician: action.payload,
				updatetechnicianLoading: false,
			};
		case types.UPDATE_TECHNICIAN_ERROR:
			return {
				...state,
				updatetechnicianError: action.payload,
				updatetechnicianLoading: false,
			};
		case types.UPDATE_TECHNICIAN_RESET:
			return {
				...state,
				updatetechnician: null,
				updatetechnicianError: null,
				updatetechnicianLoading: false,
			};
		//singleItem
		// case types.SINGLE_MAINTENANCE_START:
		// 	return {
		// 		...state,
		// 		updatemaintenance: null,
		// 		updatemaintenanceError: null,
		// 		updatemaintenanceLoading: true,
		// 	};
		// case types.SINGLE_MAINTENANCE_SUCCESS:
		// 	return {
		// 		...state,
		// 		updatemaintenance: action.payload,
		// 		updatemaintenanceLoading: false,
		// 	};
		// case types.SINGLE_MAINTENANCE_ERROR:
		// 	return {
		// 		...state,
		// 		updatemaintenanceError: action.payload,
		// 		updatemaintenanceLoading: false,
		// 	};
		// case types.SINGLE_MAINTENANCE_RESET:
		// 	return {
		// 		...state,
		// 		updatemaintenanceError: null,
		// 		updatemaintenanceLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default StoreReducer;
